import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "@/index.css";
import { App } from "@/App";
import { log } from "@/lib/log";
import { chunkRecovery, listenForPreloadErrors } from "@/lib/chunkRecovery";
import { installNewVersionPrompt } from "@/lib/updatePrompt";

// A lazy chunk of an old build that a deploy deleted: reload once onto the current build.
listenForPreloadErrors(window, chunkRecovery);

const rootEl = document.getElementById("root");
if (!rootEl) {
  throw new Error("Missing #root element in index.html");
}

createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

if ("serviceWorker" in navigator && !import.meta.env.DEV) {
  // Before registering: the prompt needs to know whether this page was controlled at load.
  installNewVersionPrompt();
  window.addEventListener("load", () => {
    void navigator.serviceWorker.register("/sw.js", { scope: "/" }).catch((err) => {
      log.warn("Service worker registration failed", err);
    });
  });
}
